import { showModal } from 'components/Modal/Modal.actions';
import { PendingSessionsModalName } from 'pages/accountManagement/partials/PendingSessionsModal/PendingSessionsModal.config';
import { Translate } from 'react-localize-redux';
import { useDispatch, useSelector } from 'react-redux';
import { selectPendingSessions } from 'services/pendingSessions/pendingSessions.selectors';
import colors from 'style-utils/colors';
import styled from 'styled-components';

type PendingSessionsSectionProps = {
  onClose: () => void;
};

export default function PendingSessionsBlock({
  onClose,
}: PendingSessionsSectionProps) {
  const dispatch = useDispatch();

  const pendingSessions = useSelector(selectPendingSessions);
  const { sessionsList } = pendingSessions;

  if (!sessionsList.length) return null;

  return (
    <PendingSessionRow>
      <SessionsBox>
        <Translate id="text.walletModal.pendingSessions" />
        <SessionsLink
          onClick={() => {
            dispatch(showModal(PendingSessionsModalName));
            onClose();
          }}
        >
          <Translate id="lbl.pendingSessionsBanner.see" />
        </SessionsLink>
      </SessionsBox>
    </PendingSessionRow>
  );
}

const PendingSessionRow = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 16px 0 16px;
`;

const SessionsBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  background-color: ${colors.messageBackground};
  padding: 16px 12px;
  font-size: 14px;
  font-weight: 400;
  color: ${colors.blackTwelve};
  line-height: 18px;
`;

const SessionsLink = styled.div`
  font-weight: bold;
  text-decoration: underline;
  margin-top: 6px;
  margin-left: auto;
  padding-left: 16px;
  cursor: pointer;
`;
